import { useLayoutEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const history = useHistory();
  const location = useLocation();
  const positions = useRef<Record<string, number>>({});

  useLayoutEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  useLayoutEffect(() => {
    const locationKey = location.key || `${location.pathname}${location.search}`;
    const savedPosition = positions.current[locationKey];

    if (history.action === 'POP' && savedPosition !== undefined) {
      window.scrollTo(0, savedPosition);
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      positions.current[locationKey] = window.scrollY;
    };
  }, [history.action, location.key, location.pathname, location.search]);

  return null;
}
